/* eslint-disable no-console */
import * as React from 'react';
import { render } from 'react-dom';
import { EventsList } from './EventsList';
export function initializeEventsList() {
  const root = document.getElementById('react-events-root');
  if (typeof root?.dataset?.json === 'undefined') return;
  const jsonData = JSON.parse(root.dataset.json);
  render(<EventsList jsonData={jsonData} />, root);
}
